import {
    Input,
    Component,
    Output,
    EventEmitter,
    Inject
} from '@angular/core';

import { TOAST_DATA } from '../toastr.service';

@Component({
    selector: 'app-toast-error-from-steam',
    templateUrl: './toast-error-from-steam.component.pug',
    styleUrls: ['./toast-error-from-steam.component.less'],
})
export class ToastErrorFromSteamComponent {
    @Input() count: number = null;

    @Output() select: EventEmitter<void> = new EventEmitter();

    constructor(
        @Inject(TOAST_DATA) public data: any
    ) {
    }

    onSelect() {
        this.select.emit();
    }
}
